import {
  CURRENCY,
  CURRENCY_WITH_DOT_AND_COMA,
  NEGATIVE_CURRENCY_WITH_DOT_AND_COMA,
  NEGATIVE_NUMBERS_FLOAT_COMA,
  NUMBERS_FLOAT_COMA,
} from '../constants';

const DEFAULT_OPTIONS = {
  significantDigits: 2,
  thousandsSeparator: '.',
  decimalSeparator: ',',
  symbol: '€',
} as const;

interface CurrencyFormatter {
  value?: string | number;
  options: any;
  customSymbol?: string;
}
export const currencyFormatter = ({
  value,
  options,
  customSymbol,
}: CurrencyFormatter): string => {
  if (typeof value !== 'number') value = 0.0;
  options = { ...DEFAULT_OPTIONS, ...options };
  value = value.toFixed(options.significantDigits);

  const [currency, decimal] = value.split('.');
  return `${currency.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    options.thousandsSeparator,
  )}${options.decimalSeparator}${decimal} ${customSymbol ?? options.symbol} `;
};

export const percentageFormat = (number: number, decimal?: number): string =>
  String(
    setDecimal(Math.round((number + Number.EPSILON) * 100) / 100, decimal ?? 2),
  ).concat(' %');

export const prettyPercentageFormat = (value: string): string => {
  const normalizePercentage = removeDecimalIfIsZero(value);
  return normalizePercentage.concat('%');
};

export function setDecimal(value: number | string, decimal: number): string {
  return Number(value).toFixed(decimal);
}

export const removeDecimalIfIsZero = (value?: string): string => {
  if (value) {
    const [value1, value2] = value.split('.');
    if (value2 === '00') {
      return value1;
    }
  }
  return value ?? '';
};
export const parseCurrency = (
  currencyValue: string,
  isNegative = false,
): number => {
  const currency = String(currencyValue).replace(/[€]/g, '').replace(/\s/g, '');
  if (
    currency.length &&
    ((isNegative
      ? NEGATIVE_CURRENCY_WITH_DOT_AND_COMA.test(currency)
      : CURRENCY_WITH_DOT_AND_COMA.test(currency)) ||
      (isNegative
        ? NEGATIVE_NUMBERS_FLOAT_COMA.test(currency)
        : NUMBERS_FLOAT_COMA.test(currency)))
  ) {
    const parsedCurrency = currency
      .split(',')
      .reduce((accumulator, current) => {
        const replacedCurrent = current.replace(/[.]/g, '');
        return (accumulator += accumulator
          ? replacedCurrent
          : replacedCurrent + '.'); // TODO Verificare codice
      }, '');
    return Number(parsedCurrency);
  }
  return Number(currency ?? 0);
};

export const parsePercent = (percentValue: string): number => {
  const percent = String(percentValue).replace(/\s[%]/g, '');
  return Number(percent);
};

export const applyPercentage = (
  netValue: number,
  percentValue: number,
): number => {
  return netValue + (netValue * percentValue) / 100;
};

export const deductPercentage = (value: number, percentValue: number): number =>
  value / (1 + percentValue / 100);

export const getSymbolOfCurrencyByTenant = (
  tenantCurrency?: string,
): string => {
  return (
    CURRENCY.find((country) => country.code === tenantCurrency)?.symbol ?? '€'
  );
};
